<template>
  <v-card style="overflow: auto">
    <v-divider style="margin:0px"></v-divider>
    <v-card-text style="padding-top:0px">

      <v-data-table
        :pagination.sync="pagination"
        :rows-per-page-items="pagination.rowsPerPageItems"
        :total-items="pagination.totalItems"
        :items="items"
        :headers="headers"
        class="v-table-list theme--light table-default"
      >
        <template slot="items" scope="props">
          <tr v-bind:class="{table__selected:props.selected}">
            <td width="1%">
              
            </td>
            <!-- <td
              class="text-xs-left cut-text"
            >{{moment(props.item.creationDate,"DD/MM/YYYY HH:mm").format('DD/MM/YYYY HH:mm')}}</td> -->
            <td class="text-xs-left cut-text corto-min">{{ props.item.Sistema }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.Ramo }}</td>
            <td class="text-xs-left cut-text grande-min">{{ props.item.Identificacion }}</td>
            <td class="text-xs-left cut-text extragrande-min">{{ props.item.Cliente }}</td>
            <td class="text-xs-left cut-text grande-min">{{ props.item.Endoso }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.Prima | currency }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.Comision | currency }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.Liquidacion }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.Recibo }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.Poliza }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.Estado }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.Tipo }}</td>
            <td class="text-xs-left cut-text grande-min">{{ props.item.NumFinanciamiento }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.Cuota }}</td>
            <td class="text-xs-left cut-text extragrande-min">{{ props.item.Producto }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.Aps }}</td>            
            <td class="text-xs-left cut-text medio-min">{{ props.item.FechaPago }}</td>
            <td class="text-xs-left cut-text medio-min">{{ props.item.FechaCreacion }}</td>
            <td class="text-xs-left cut-text medio-min">{{ props.item.FechaModificacion }}</td>
          </tr>
        </template>

        <template slot="no-data">
          <div>{{$t('message.noPreliquidations')}}</div>
        </template>
        <!-- <template
          slot="pageText"
          slot-scope="props"
        >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>  -->
      </v-data-table>
   
    </v-card-text>
  </v-card>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";

export default {
  props: {
       items: {
           type: Array
       }
  },
  computed: {
    ...mapGetters(["loadingCommission", "agency"])
  },
  mounted() {
    //this.$store.dispatch("getCommissionsLiquidation");
    /*     for(let i=0;i<=this.commissionsLiquidation.length; i++)
     {
       this.selectRow.push(this.commissionsLiquidation[i]);       
     } */
  },
  methods: {
    nzDate: nzDate,
    uniqueCheck(e, index) {
      for (let i = 0; i < this.selectRow.length; i++) {
        if (index != i) {
          this.selectRow[i] = false;
        }
      }
      if (!this.selectRow[index]) {
        this.selectedValue = null;
      } else {
        this.selectedValue = e;
      }
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index === "creationDate") {
          let dateA = new Date(this.getDate(a[index]));
          let dateB = new Date(this.getDate(b[index]));
          /* let demoInvalidDate=new Date(a[index])
            if(demoInvalidDate=='Invalid Date'){
              var formattedA = moment(a[index]).format('D MMMM YYYY');
              //var formattedB = moment(demoInvalidDate).format('D MMMM YYYY');
              console.log(a[index],formattedA)
           
            } */
          if (!isDesc) {
            return dateA < dateB ? -1 : 1;
          } else {
            return dateB < dateA ? -1 : 1;
          }
        } else {
          if (!isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      });
      return items;
    },
    getDate(d) {
      var day, month, year;

      let result = String(d).match("[0-9]{2}([-/ .])[0-9]{2}[-/ .][0-9]{4}");
      if (null != result) {
        let dateSplitted = result[0].split(result[1]);
        day = dateSplitted[0];
        month = dateSplitted[1];
        year = dateSplitted[2];
      }
      result = String(d).match("[0-9]{4}([-/ .])[0-9]{2}[-/ .][0-9]{2}");
      if (null != result) {
        let dateSplitted = result[0].split(result[1]);
        day = dateSplitted[2];
        month = dateSplitted[1];
        year = dateSplitted[0];
      }

      if (month > 12) {
        let aux = day;
        day = month;
        month = aux;
      }

      return year + "/" + month + "/" + day;
    },
    changeSort(column) {
      this.selectedValue = null;
      (this.selectRow = []), (this.additional_grouped = []);
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
        this.additional_grouped[0] = this.selectedValue;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
        this.additional_grouped[0] = this.selectedValue;
      }
      // console.log(this.pagination.sortBy)
    },
    refresh() {
      this.$store.dispatch("getCommissionsLiquidation").then(() => {
        this.selectedValue = null;
        this.additional_grouped = [];
      });
    },
    enter() {
      // if (this.searchValue != "") {
      //   this.$store.dispatch("getCommissionsLiquidation", this.searchValue);
      // } else {
      //   this.$store.dispatch("getCommissionsLiquidation");
      // }
    }
  },
  watch: {
    loadingCommission(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val) {
      //this.$store.dispatch("getCommissionsLiquidation");
    }
  },
  data() {
    return {
      scrollSync : {
            top: 0,
            left: 0
         },
      selectedValue: null,
      selectRow: 0,
      additional_grouped: [],
      searchValue: "",
      matches: [],
      pagination: {
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
        rowsPerPageItems: [5, 10, 15, 25],
        sortBy: "creationDate"
      },
      selected: [],
      headers: [
        {
          align: "left",
          sortable: false,
          text: "",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Sistema",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "Ramo",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "Cod. Cliente",
          value: "",
          width: "10%"
        },
        {
          align: "left",
          sortable: false,
          text: "Cliente",
          value: "",
          width: "15%"
        },
        {
          align: "left",
          sortable: false,
          text: "Endoso",
          value: "",
          width: "10%"
        },
        {
          align: "left",
          sortable: false,
          text: "Prima",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "Comision",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "Liquidación",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "RP",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.policy"),
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.status"),
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "Tipo",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "# Financiamiento",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "Cuota",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "Producto",
          value: "",
          width: "10%"
        },
        {
          align: "left",
          sortable: false,
          text: "APS",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "Fecha Pago",
          value: "",
          width: "15%"
        },
        {
          align: "left",
          sortable: false,
          text: "Fecha Creación",
          value: "",
          width: "15%"
        },
        {
          align: "left",
          sortable: false,
          text: "Fecha Modificación",
          value: "",
          width: "15%"
        }
      ]
    };
  }
};
</script>
<style scoped>
.medio-min{
   min-width: 120px;
 }

.grande-min{
   min-width: 150px;
 }

 .extragrande-min{
   min-width: 200px;
 }
 .corto-min{
   min-width: 80px;
 }
</style>